// extracted by mini-css-extract-plugin
module.exports = {"_heading":"Heading__heading__1g6e3","flicker":"Heading_flicker__qJcX_"};